import { useCallback } from "react";

import { useHistory } from "react-router";

import { useGetBalances } from "~/v2/api/hooks/useGetBalances";
import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { parseMoney } from "../overview.format";
import { CashCardPresentation } from "./CashCard.pres";

export const CashCard = () => {
  const history = useHistory();
  const { currentAccount, product } = useAccountContext();
  const accountID = currentAccount?.id;
  const isAccountReady = Boolean(accountID && product);

  const { data, isLoading, isError } = useGetBalances({
    accountID: accountID ?? "",
    paper: product === "paper",
    options: {
      enabled: isAccountReady,
      meta: { showErrorToast: false },
    },
  });
  const margin = data?.current ?? undefined;

  const onFund = useCallback(() => {
    history.push(Path.ROUTE_FUNDING_DEPOSIT);
  }, [history]);
  const onWithdraw = useCallback(() => {
    history.push(Path.ROUTE_FUNDING_WITHDRAW);
  }, [history]);

  return (
    <CashCardPresentation
      cash={parseMoney(margin?.cash)}
      cashWithdrawable={parseMoney(margin?.cash_withdrawable)}
      onFund={onFund}
      onWithdraw={onWithdraw}
      isPaperAccount={product === "paper"}
      isLoading={isAccountReady && isLoading}
      hasError={isError}
    />
  );
};
